import axios from "axios/index";
import * as api from "../constants";
import * as types from '../types/app';

export function getServerTime() {
  return dispatch => {
    dispatch({type: types.APP_SERVER_TIME});
    return axios.get(api.CURRENT_TIME);
  }
}


// WEBPACK FOOTER //
// ./src/actions/appActions.js